import React from "react";

const DownloadReport = ({ handleTimeByProgramExport }) => {
  return (
    <div>
      <button className="c-b-btn" onClick={() => handleTimeByProgramExport()}>
        {" "}
        <img src="/assets/images/report-icon.svg" alt="" className="me-2" />{" "}
        Download Report
      </button>
    </div>
  );
};

export default DownloadReport;
